import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-waterdata',
  templateUrl: './waterdata.component.html',
  styleUrls: ['./waterdata.component.css']
})
export class WaterdataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
